<template>
	<templates-limit-exceeded v-if="reachedCampaignLimit" />
	<core-page v-else classes="templates-wrapper">
		<common-page-tabnav current="templates" :tabs="tabs" />
		<h1>Select a Campaign Type:</h1>
		<common-alerts :alerts="alerts" />
		<div class="templates-content">
			<templates-types />
			<templates-filters />

			<div class="omapi-content-area">
				<templates-upsell-alerts />

				<div v-if="hasTemplates" class="omapi-template-listing-wrap">
					<templates-grid :templates="selectedTemplates" />
					<svg-loading v-if="isLoading" :style="{ margin: '0 auto' }" />
				</div>

				<div v-else-if="isLoading" class="archie-loader-wrapper">
					<div><core-loading class="loader" /></div>
				</div>

				<div v-else class="no-templates-available">
					<core-alert :type="validType ? 'info' : 'warn'">
						<div class="alert-message">
							{{ noTemplatesMessage }}
						</div>
					</core-alert>
				</div>
			</div>
		</div>
		<campaigns-modal-create-campaign />
		<templates-modal-not-connected />
		<templates-modal-no-access />
	</core-page>
</template>

<script lang="js">
import orderBy from 'lodash/orderBy'
import upperFirst from 'lodash/upperFirst'
import { mapActions, mapState, mapGetters } from 'vuex'
import { templatePreviewsSetup } from 'optinmonster-js-library/src/vue/templates/mixins/templatePreviewsSetup'
import { creation } from '@/components/mixins/creation'

export default  {
	mixins : [ templatePreviewsSetup, creation ],
	computed : {
		...mapState('templates', [
			'activeType',
			'search',
			'sort',
			'popular',
			'templates',
		]),
		...mapGetters([ 'reachedCampaignLimit' ]),
		...mapGetters('templates', [ 'typePermitted', 'featured', 'filters', 'filterGamified', 'validType' ]),
		alerts () {
			return this.$get('$store.state.alerts', [])
		},
		isLoading () {
			return this.$store.getters.isLoading('templates')
		},
		popularTemplates () {
			const popular = this.popular[this.activeType]

			return popular && popular.length ? this.order(popular) : []
		},
		featuredTemplates () {
			const featured = this.featured[this.activeType]

			return featured && featured.length ? this.order(featured) : []
		},
		showableTemplates () {
			const filterPasses = (key, value) => {
				return this.filters[key].length
					? !this.filters[key].find(f => !value.includes(f))
					: true
			}

			const prop = [ 'popular', 'featured' ].includes(this.sort) ? `${this.sort}Templates` : 'templates'
			const templates = this[ prop ]
				.filter((template) => {
					if ('' === this.search) {
						return true
					}
					return template.name.toLowerCase().includes(this.search.toLowerCase())
				}).filter((template) => {
					const device = 'mobile' === this.filters.device
						? template.mobile
						: !template.mobile

					if (!device) {
						return false
					}

					const taxonomies = [ 'goals', 'categories', 'tags' ]

					return !taxonomies.find(t => {
						return !filterPasses(t, template[t].map(term => term.id))
					})
				})

			return this.order(templates)
		},
		selectedTemplates () {
			return this.showableTemplates.filter(template => {
				return this.filterGamified
					? template.tags.find(tag => 1 === tag.id)
					: template.type === this.activeType
			})
		},
		hasTemplates () {
			return this.selectedTemplates.length
		},
		shouldShowUpsells () {
			return this.$store.getters.connected
				? !this.typePermitted(this.activeType)
				: false
		},
		noTemplatesMessage () {
			return this.validType
				? 'No templates available for your current selection.'
				: `${upperFirst(this.activeType)} is not a valid type. Please select one of the options above.`
		},
	},
	created () {
		this.$store.dispatch('campaigns/fetchDashboard').catch(() => {})

		this.loadApiScript('omwpapi-templates-apijs', this.$constants.TEMPLATES_PREVIEW_ACCOUNT, this.$constants.TEMPLATES_PREVIEW_USER)
	},
	mounted () {
		this.fetchTemplateData().catch(() => {})
		this.$bus.$emit('dashboard-view-mounted', 'templates')
	},
	methods : {
		...mapActions('templates', [ 'fetchTemplateData' ]),
		applyFilters (filters) {
			this.$bus.$emit('applied-bulk-filter')
			this.$store.commit('templates/appliedFilters', filters)
		},
		order (templates) {
			return orderBy(templates, (template) => {
				return 'recent' === this.sort || 'featured' === this.sort ? -this.$moment(template.created_at).valueOf() : template.name
			})
		},
	},

};
</script>
<style lang="scss">
@import '../assets/scss/variables';
@import '../assets/scss/pages/templates';
</style>
